import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { Tab, Tabs } from "@/components/Tabs";
import {
  rudderAnalytics,
  FlightSearchTrackingEvents,
  HotelSearchTrackingEvents,
} from "@/lib/rudderstack";

type SearchCategorySwitcherProps = {
  current: "flights" | "hotels";
};

const eventMap = {
  flights: FlightSearchTrackingEvents.USER_SWITCHED_TO_FLIGHT_SEARCH,
  hotels: HotelSearchTrackingEvents.USER_SWITCHED_TO_HOTEL_SEARCH,
} as const;

export const SearchCategorySwitcher = ({
  current,
}: SearchCategorySwitcherProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <Tabs
      value={current}
      onChange={(newCategory) => {
        if (eventMap[newCategory]) {
          rudderAnalytics.track(eventMap[newCategory]);
        }

        if (newCategory === "flights") {
          navigate({
            to: "/flights/search",
            replace: true,
          });

          return;
        }

        navigate({
          to: "/hotels/search",
          replace: true,
        });
      }}
    >
      <Tab
        value="flights"
        label={intl.formatMessage({
          description: "Navigation label for the Flights section",
          defaultMessage: "Flights",
        })}
      />
      <Tab
        value="hotels"
        label={intl.formatMessage({
          description: "Navigation label for the Hotels section",
          defaultMessage: "Hotels",
        })}
      />
    </Tabs>
  );
};
